import React from "react";
import { styled, Switch } from "@mui/material";

const SwitchComponent = ({ checked, defaultChecked, onChange, sx, ...rest }) => {
  // Support both prop names as controlled, same as the old behavior
  const isChecked = checked ?? defaultChecked;

  return (
    <Switch
      checked={isChecked === undefined ? undefined : !!isChecked}
      onChange={onChange}
      {...rest}
      sx={{
        minWidth: "36px",
        minHeight: "20px",
        flexShrink: 0,
        "& .MuiSwitch-switchBase.Mui-checked": {
          color: "#fff",
        },
        "& .MuiSwitch-thumb": {
          color: "#fff",
        },
        ...sx,
      }}
    />
  );
};

const LargeSwitch = styled(SwitchComponent)(() => ({
  maxHeight: "24px !important",
  maxWidth: "44px !important",
  "& .MuiSwitch-thumb": {
    width: 20,
    height: 20,
  },
}));

export { SwitchComponent, LargeSwitch };